import React from 'react';
import type { PreviewColorScheme } from '../WebsitePreview';

const LandingPreview: React.FC<{ scheme: PreviewColorScheme }> = ({ scheme }) => (
  <div style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '12px' }}>
    {/* Nav */}
    <nav
      style={{ backgroundColor: scheme.surface, borderBottom: `1px solid ${scheme.border}`, padding: '10px 20px' }}
      className="flex items-center justify-between"
    >
      <div style={{ color: scheme.primary, fontWeight: 700, fontSize: '14px' }}>Sample brand</div>
      <div className="flex gap-4">
        {['Features', 'Pricing', 'About'].map(t => (
          <span key={t} style={{ color: scheme.textMuted, fontSize: '11px' }}>{t}</span>
        ))}
        <span
          style={{ backgroundColor: scheme.primary, color: '#fff', padding: '3px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}
        >
          Sign Up
        </span>
      </div>
    </nav>

    {/* Hero */}
    <div style={{ padding: '32px 20px', textAlign: 'center' }}>
      <h3 style={{ color: scheme.text, fontSize: '22px', fontWeight: 800, marginBottom: '8px', lineHeight: 1.2 }}>
        Preview your landing page
      </h3>
      <p style={{ color: scheme.textMuted, maxWidth: '360px', margin: '0 auto 16px', lineHeight: 1.5 }}>
        See your selected colors on headings, surfaces and example actions.
      </p>
      <div className="flex gap-2 justify-center">
        <span style={{ backgroundColor: scheme.primary, color: '#fff', padding: '8px 20px', borderRadius: '6px', fontWeight: 600 }}>
          Get Started
        </span>
        <span style={{ border: `1px solid ${scheme.border}`, color: scheme.text, padding: '8px 20px', borderRadius: '6px', fontWeight: 500 }}>
          Learn More
        </span>
      </div>
    </div>

    {/* Features */}
    <div style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
      {[
        { title: 'Primary action', desc: 'Try your primary color on an example action.' },
        { title: 'Supporting surface', desc: 'Compare a card with the page background.' },
        { title: 'Reading text', desc: 'Inspect a short heading and supporting copy.' },
      ].map(f => (
        <div key={f.title} style={{ backgroundColor: scheme.surface, border: `1px solid ${scheme.border}`, borderRadius: '8px', padding: '14px' }}>
          <div style={{ width: '28px', height: '28px', borderRadius: '6px', backgroundColor: scheme.secondary, marginBottom: '8px', opacity: 0.8 }} />
          <div style={{ fontWeight: 700, color: scheme.text, marginBottom: '4px' }}>{f.title}</div>
          <div style={{ color: scheme.textMuted, fontSize: '11px', lineHeight: 1.4 }}>{f.desc}</div>
        </div>
      ))}
    </div>

    {/* CTA Banner */}
    <div style={{ margin: '12px 20px 20px', padding: '20px', borderRadius: '10px', background: `linear-gradient(135deg, ${scheme.primary}, ${scheme.secondary})`, textAlign: 'center' }}>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: '15px', marginBottom: '4px' }}>Example call to action</div>
      <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '11px', marginBottom: '10px' }}>Sample content for inspecting your palette in a layout.</div>
      <span style={{ backgroundColor: '#fff', color: scheme.primary, padding: '6px 16px', borderRadius: '5px', fontWeight: 600 }}>
        Example action
      </span>
    </div>
  </div>
);

export default LandingPreview;
